import type { TrendRangeMonths } from "../types";

export const TREND_RANGE_OPTIONS: TrendRangeMonths[] = ["3 Months", "6 Months", "12 Months"];

export const TREND_ACTUAL_KEYS = ["Overdue", "OverdueException", "Exception", "OnTrack"] as const;
export const TREND_ACTUAL_KEYS_WITH_NEW = [...TREND_ACTUAL_KEYS, "New"] as const;
export const TREND_FORECAST_KEYS = [
  "WillBecomeOverdue",
  "OverdueException",
  "Exception",
  "OnTrack",
] as const;

export const TREND_CATEGORY_LABELS: Record<string, string> = {
  Overdue: "Overdue",
  WillBecomeOverdue: "Will Become Overdue",
  OverdueException: "Remediation Plan",
  Exception: "Exception",
  OnTrack: "On Track",
  New: "New",
  Drift: "Drift",
};

/** Reverse map: rotated bar label -> backend category code (for drilldowns). */
export const TREND_LABEL_TO_CODE: Record<string, string> = Object.fromEntries(
  Object.entries(TREND_CATEGORY_LABELS).map(([code, label]) => [label, code]),
);

export const TREND_SEVERITIES = [
  { key: "low", label: "Low" },
  { key: "medium", label: "Medium" },
  { key: "high", label: "High" },
  { key: "critical", label: "Critical" },
] as const;

export const TREND_LEGEND_DATA = ["Critical", "High", "Medium", "Low"];

/** Categories whose drilldown rows cannot be selected for bulk manage actions. */
export const TREND_MANAGE_EXCLUDED_CATEGORIES = new Set(["Exception", "OverdueException", "Drift"]);

/** Raw month bucket ("Jan-2026") -> display label ("Jan 2026"). */
export const trendDisplayMonth = (raw: string): string => raw.replace(/-/g, " ");
